import React, { Component } from 'react';
import './MiniMessage.css';

export default class MiniMessage extends Component{
  render() {
    return (
      <div className="mini">{this.props.content}</div>
    )
  }
}